
<mat-dialog-content >

    <app-recherche recherche="ecarticleauto2" displayColumn="Art_Des" name="article" (clickClearText)="ClearText()" [(ngModel)]="art" placeholder="Article"></app-recherche>
  
  <mat-dialog-actions>
    <button class="mat-raised-button" (click)="close()">Close</button>
    <button class="mat-raised-button mat-primary" (click)="save()">Choisir</button>
  </mat-dialog-actions>
</mat-dialog-content>